import { LazyLoadedStatesManager } from '../class/lazy-loaded-states-manager.class';
import { LazyLoadedStates } from '../interfaces/lazy-loaded-states.interface';

export const AdministrationLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    styleExample: LazyLoadedStates,
    portalSettings: LazyLoadedStates,
    landing: LazyLoadedStates,
    ratingForm: LazyLoadedStates,
    alert: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.administration',
        url: '/administration',
        abstract: true
    },
    styleExample: {
        name: 'authenticated.administration.styleExample',
        url: '/styleExample',
    },
    portalSettings: {
        name: 'authenticated.administration.portalSettings',
        url: '/portalSettings'
    },
    landing: {
      name: 'authenticated.administration.landing',
      url: '/admin-landing'
    },
    ratingForm: {
      name: 'authenticated.administration.ratingform',
      url: '/rating-form-management'
    },
    alert: {
        name: 'authenticated.administration.alert',
        url: '/alert'
    }
},
() => import('src/app/administration/administration.module').then((result: {AdministrationModule: any}) => result.AdministrationModule)
);
